import React, {
  useMemo,
  useRef,
  useState,
  useCallback,
  useEffect,
} from "react";
import BreadCrumb from "Common/BreadCrumb";
import { PaginationState } from "@tanstack/react-table";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import {
  MoreHorizontal,
  Eye,
  FileEdit,
  Trash2,
  UploadCloud,
} from "lucide-react";
import { Download, Plus, Search, SlidersHorizontal } from "lucide-react";

import HTMLReactParser from "html-react-parser";
import DeleteModal from "Common/DeleteModal";
import callApi from "Common/utils/apiCaller";
import { Pencil } from "lucide-react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import _ from "lodash";
import Drawer from "Common/Components/Drawer";
import { X } from "lucide-react";
import Modal from "Common/Components/Modal";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import PermissionSwitch from "../../Common/Components/PermissionLocks/PermissionSwitch";
import ImageView from "Common/Components/ImageView/ImageView";
import { showNotification } from "Common/utils/Notification";
import document from "../../images/PDF_file_icon.svg";

const NoticeList = () => {
  const [notice, setNotice] = useState([]);
  const [loader, setLoader] = useState<any>(false);
  const [search, setSearch] = useState<any>();
  const [showModel, setShowModel] = useState<boolean>(false);
  const [read, setRead] = useState<any>("");
  const defaultToggle = () => setShowModel(!showModel);
  const [pageCount, setPageCount] = useState(0);
  const [eventData, setEventData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [totalItems, setTotalItems] = useState(0);
  const [render, setRender] = useState(false);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [imageLink, setImageLink] = useState<any>();
  const [imageData, setImageData] = useState<any>();
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.media_type === "document") {
        setImageLink(imageData);
      } else {
        showNotification("Please select pdf", "error");
      }
    }
  }, [imageData]);

  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      user: profile.user,
      error: profile.error,
      success: profile.success,
      permission: profile.permission,
    })
  );

  const { error, success, user, permission } = useSelector(selectProperties);

  const deleteToggle = () => setDeleteModal(!deleteModal);
  const debouncedHandler = useCallback(
    _.debounce((user: any, render: any, pagination: any) => {
      return fetchDateWithFilters(user, render, pagination);
    }, 700),
    []
  );

  async function fetchDateWithFilters(
    searchByName: any,
    render: any,
    pagination: any
  ) {
    let filters: { [index: string]: any } = {};
    if (searchByName) {
      filters.qtext = searchByName;
    }

    const localData = await callApi("v1/notice/list", "post", {
      pageNum: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      filters,
    });
    let arr = [];
    if (localData?.status === "Success") {
      setNotice([...localData.data.noticeList]);
      setPageCount(Math.ceil(localData.data.noticeCount / pagination.pageSize));
      setTotalItems(localData.data.noticeCount);
    }
  }

  const filterSearchData = (e: any) => {
    const search = e.target.value;

    setSearch(search);
  };

  useEffect(() => {
    debouncedHandler(search, render, pagination);
  }, [search, render, pagination]);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell._id) {
      setEventData(cell);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      //dispatch(onDeleteEmployee(eventData.id));

      const res = await callApi(`v1/notice/${eventData?._id}/update`, "post", {
        notice: { is_deleted: true },
      });
      if (res && res?.status === "Success") {
        setDeleteModal(false);
        setRender(!render);
        toast("Deleted successfully");
      }
    }
  };

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });

    setIsEdit(true);
    setShow(true);
  };

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      heading: (eventData && eventData.heading) || "",

      description: (eventData && eventData.description) || "",
      // image_url: (imageLink && imageLink?.media_url) || "",
    },
    validationSchema: Yup.object({
      heading: Yup.string().required("Please enter heading"),

      description: Yup.string().required("Please enter description"),
      // image_url: Yup.string().required("Please select image"),
    }),

    onSubmit: async (values) => {
      if (isEdit) {
        const updateData = {
          _id: eventData ? eventData._id : 0,
          ...values,
        };
        if (!!!imageLink?.media_url) {
          showNotification("Please add document", "error");
          return;
        }
        // update user
        try {
          setLoader(true);
          const res = await callApi(
            `v1/notice/${eventData?._id}/update`,
            "post",
            {
              notice: {
                ...values,
                link: imageLink?.media_url,
              },
            }
          );
          setLoader(false);
          if (res && res?.status === "Success") {
            setRender(!render);
            toast("Updated successfully");
          }
        } catch (e) {
          toast("something went wrong");
        }
      } else {
        try {
          if (!!!imageLink?.media_url) {
            showNotification("Please add document", "error");
            return;
          }
          setLoader(true);
          const res = await callApi(`v1/notice/new`, "post", {
            notice: {
              ...values,
              link: imageLink?.media_url,
            },
          });
          setLoader(false);
          if (res && res?.status === "Success") {
            setRender(!render);
            toast("notice created successfully");
          }
        } catch (e) {
          toast("something went wrong");
        }
      }
      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const noticeColumns = useMemo(
    () => [
      {
        header: "Heading",
        accessorKey: "heading",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Link",
        accessorKey: "link",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <Link
            to={getImageUrl(cell.row.original.link)}
            className="flex items-center gap-3 "
            target="_blank"
          >
            <div className="rounded-full size-6 shrink-0 bg-slate-100">
              <img
                src={document}
                alt="application/pdf"
                // width="165"
                // height="165"
                className="rounded-full size-6"
              />
            </div>
          </Link>
        ),
      },

      {
        header: "Description",
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <Link to="#!" className="flex items-center gap-3">
            <div>
              {HTMLReactParser(
                cell.row.original.description?.slice(0, 30) ?? ""
              )}

              {cell.row.original.description?.length > 30 ? (
                <>
                  {" ..."}
                  <span
                    style={{
                      color: "#fb801d",
                    }}
                    onClick={() => {
                      // setReadText("Text");
                      setRead(cell.row.original.description);
                      defaultToggle();
                    }}
                  >
                    more
                  </span>
                </>
              ) : null}
            </div>
          </Link>
        ),
      },

      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <PermissionSwitch
              hasPermissions={permission.permissions}
              shouldHavePermissions={["notice:edit"]}
              yes={
                <div
                  data-modal-target="addEmployeeModal"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md cursor-pointer size-8 edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    handleUpdateDataClick(data);
                  }}
                >
                  <Pencil className="size-4" />
                </div>
              }
              no={<span></span>}
            />
            <PermissionSwitch
              hasPermissions={permission.permissions}
              shouldHavePermissions={["notice:delete"]}
              yes={
                <Link
                  to="#!"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    onClickDelete(data);
                  }}
                >
                  <Trash2 className="size-4" />
                </Link>
              }
              no={<span></span>}
            />
          </div>
        ),
      },
    ],
    []
  );

  return (
    <>
      <React.Fragment>
        <BreadCrumb title="notice" pageTitle="notice" version="" />
        <DeleteModal
          show={deleteModal}
          onHide={deleteToggle}
          onDelete={handleDelete}
        />
        <ToastContainer closeButton={false} limit={1} />
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div className="card-body">
              <div className="flex items-center">
                <h6 className="text-15 grow">Notice</h6>
                <div className="shrink-0">
                  <PermissionSwitch
                    hasPermissions={permission.permissions}
                    shouldHavePermissions={["notice:create"]}
                    yes={
                      <button
                        type="button"
                        className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        onClick={toggle}
                      >
                        <Plus className="inline-block size-4" />{" "}
                        <span className="align-middle">Add Notice</span>
                      </button>
                    }
                    no={
                      <button
                        type="button"
                        disabled={true}
                        className="text-grey btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        onClick={null}
                      >
                        <Plus className="inline-block size-4" />{" "}
                        <span className="align-middle">Add Notice</span>
                      </button>
                    }
                  />
                </div>
              </div>
            </div>
            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form action="#!">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="relative xl:col-span-3">
                    <input
                      type="text"
                      className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Search for notices..."
                      autoComplete="off"
                      onChange={(e) => filterSearchData(e)}
                    />
                    <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  </div>
                </div>
              </form>
            </div>
            <div className="card-body">
              <TableContainer
                isPagination={true}
                columns={noticeColumns || []}
                data={notice || []}
                pageCount={pageCount}
                pagination={pagination}
                totalItems={totalItems}
                onPaginationChange={(updater: any) => {
                  const nextState = updater(pagination);
                  if (nextState.pageIndex !== pagination.pageIndex)
                    setPagination(nextState);
                }}
                divclassName="overflow-x-auto"
                tableclassName="w-full whitespace-nowrap"
                theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
                thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
                tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
                PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
              />
            </div>
          </div>
        </div>
        {/* Employee Modal */}
        <Drawer
          show={show}
          onHide={toggle}
          id="drawerEnd"
          drawer-end="true"
          className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
        >
          <Drawer.Header
            className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
            closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
          >
            <Drawer.Title className="text-15">
              {!!isEdit ? "Edit Notice" : "Add Notice"}
            </Drawer.Title>
            <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
          </Drawer.Header>
          <Drawer.Body className="h-full p-4 overflow-y-auto">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Heading
                  </label>
                  <input
                    type="text"
                    id="phoneNumberInput3"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter heading"
                    name="heading"
                    onChange={validation.handleChange}
                    value={validation.values.heading || ""}
                  />
                  {validation.touched.heading && validation.errors.heading ? (
                    <p className="text-red-400">{validation.errors.heading}</p>
                  ) : null}
                </div>
                <div className="m-4 ml-0 xl:col-span-12">
                  {imageLink ? (
                    <div className="flex items-center">
                      <div className="relative w-40 h-40">
                        <embed
                          src={getImageUrl(imageLink?.media_url)}
                          type="application/pdf"
                          width="165"
                          height="165"
                        />
                        <span
                          style={{
                            position: "absolute",
                            top: "0px",
                            right: "6px",
                            fontSize: "22px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setImageData(null);
                            setImageLink(null);
                          }}
                        >
                          ×
                        </span>
                      </div>
                      <div className="h-3 ml-3">
                        <div
                          onClick={() => {
                            setImageData(undefined);
                            toggleImage();
                          }}
                          // htmlFor="uploadimage49"
                          className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                          Change
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div
                        onClick={() => {
                          setImageData(undefined);
                          toggleImage();
                        }}
                        //htmlFor="uploadimage59"
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        {"Add Document"}
                      </div>
                    </>
                  )}
                </div>
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Description
                  </label>
                  <textarea
                    data-type="text"
                    rows={4}
                    id="phoneNumberInput3"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Description"
                    name="description"
                    onChange={validation.handleChange}
                    value={validation.values.description || ""}
                  />
                  {validation.touched.description &&
                  validation.errors.description ? (
                    <p className="text-red-400">
                      {validation.errors.description}
                    </p>
                  ) : null}
                </div>
              </div>

              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={toggle}
                >
                  Cancel
                </button>
                <button
                  disabled={loader}
                  type="submit"
                  id="addNew"
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loader ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : !!isEdit ? (
                    "Update Notice"
                  ) : (
                    "Add Notice"
                  )}
                </button>
              </div>
            </form>
          </Drawer.Body>
        </Drawer>
        <Modal
          show={showModel}
          onHide={defaultToggle}
          id="defaultModal"
          modal-center="true"
          className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
          dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600 flex flex-col h-full"
        >
          <Modal.Header
            className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
            closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500 dark:text-zink-200 dark:hover:text-red-500"
          >
            <Modal.Title className="text-16">{"Text"}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
            {/* <h5 className="mb-3 text-16">{}</h5> */}
            <p className="text-slate-500 dark:text-zink-200">
              {HTMLReactParser(read ?? "")}
            </p>
          </Modal.Body>
        </Modal>
        <Drawer
          show={showImage}
          onHide={toggleImage}
          id="drawerEnd"
          drawer-end="true"
          className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
        >
          <Drawer.Header
            className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
            closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
          >
            <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
            <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
          </Drawer.Header>
          <Drawer.Body className="h-full p-4 overflow-y-auto">
            <ImageView
              showImage={showImage}
              setEventData={setImageData}
              togleImage={toggleImage}
            />
          </Drawer.Body>
        </Drawer>
      </React.Fragment>
    </>
  );
};

export default NoticeList;
